// Durations are milliseconds; frame deltas below are seconds.
export const introConfig = {
	enabled: true,
	autoExpand: true,
	autoExpandDelayMs: 300,
	startupTimeoutMs: 10000,
	maxScale: 1.45,
	viewportWidthRatio: 0.82,
	viewportHeightRatio: 0.74,
	dockDurationMs: 700,
	dockSettleMs: 20,
	revealDurationMs: 380,
	revealStaggerMs: 140,
	revealEasing: "cubic-bezier(.22,1,.36,1)",
	revealOffsetPx: 12,
	revealEndPaddingMs: 190,
	dockEasing: "cubic-bezier(.22,.68,.18,1)",
};

// Maximum extra rotation from the resting view, in degrees.
export const PARALLAX = {
	enabled: true,
	maxLeftDeg: 25,
	maxRightDeg: 10,
	maxPitchDeg: 19,
	response: 7.5,
	// Stop redrawing once the remaining camera movement is imperceptible (radians).
	snapTolerance: 0.00001,
};

export const morphConfig = {
	response: 4.5,
	maxFrameDeltaSeconds: 0.05,
	snapTolerance: 0.0005,
	dockThreshold: 0.995,
	linkThreshold: 0.99,
	heightReference: 16,
	maxRiseDelay: 0.28,
	growthDuration: 0.72,
	hiddenScale: 0.001,
	hiddenY: -0.1,
	flatVoxelY: 0.025,
	flatVoxelHeight: 0.05,
};

// Content sections are revealed in this order (also used by the CSS template).
export const revealOrder = { bio: 0, projects: 1, contacts: 2 };
export const revealEndMs =
	introConfig.revealDurationMs +
	Math.max(...Object.values(revealOrder)) * introConfig.revealStaggerMs +
	introConfig.revealEndPaddingMs;

// A static QR uses the regular layout immediately when automatic expansion is off.
export const introEnabled = introConfig.enabled && introConfig.autoExpand;
